<template>
  <dash-board-layout
    :active="4"
    :title="true"
    :activeSetting="4"
    :setting="true"
  >
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Linked Account or Card</h4>
      </div>
      <div class="card-body">
        <div class="form">
          <ul class="linked_account">
            <li v-for="(item, index) in data" :key="index">
              <div class="row">
                <div class="col-9">
                  <div :class="`media ${index == 0 ? '' : 'mt-4'}`">
                    <span class="mr-3"
                      ><i
                        :class="`fa fa-cc-${
                          item.account_type == 'bank'
                            ? 'discover'
                            : item.account_type
                        }`"
                      ></i
                    ></span>
                    <div class="media-body">
                      <h5 class="mt-0 mb-1">{{ item.cardName }} Card</h5>
                      <p>{{ item.typeName }} {{ item.account_no }}</p>
                    </div>
                    <div class="edit-option">
                      <!-- <a href="#"><i class="fa fa-eye"></i></a> -->
                      <!-- <a href="#"><i class="fa fa-pencil"></i></a> -->
                      <a href="#"
                        ><i @click="delCard(item.id)" class="fa fa-trash"></i
                      ></a>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="verify">
                    <div class="verified" v-if="item.status == 1">
                      <span><i class="la la-check"></i></span>
                      <a href="#">Verified</a>
                    </div>
                    <div class="pendding" v-if="item.status == -2">
                      <span><i class="la la-edit"></i></span>
                      <router-link
                        v-if="item.is_credit"
                        :to="`/att-card-info?token=${item.id}&c=${item.account_no}`"
                        >Edit</router-link
                      >
                      <router-link
                        v-if="!item.is_credit"
                        :to="`/att-bank-address-info?token=${item.id}&c=${item.account_no}&n=${item.account_name}`"
                        >Edit</router-link
                      >
                    </div>
                    <div class="pendding" v-if="item.status == '-1'">
                      <span><i class="la la-clock-o"></i></span>
                      <a href="#">Pendding</a>
                    </div>
                    <div class="not-verify" v-if="item.status == 0">
                      <span><i class="la la-close"></i></span>
                      <a href="#">Not verified</a>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <!-- <li>
              <div class="row">
                <div class="col-9">
                  <div class="media">
                    <span class="mr-3"><i class="fa fa-bank"></i></span>
                    <div class="media-body">
                      <h5 class="mt-0 mb-1">Bank of America</h5>
                      <p>Bank **************5421</p>
                    </div>
                    <div class="edit-option">
                      <a href="#"><i class="fa fa-eye"></i></a>
                      <a href="#"><i class="fa fa-pencil"></i></a>
                      <a href="#"><i class="fa fa-trash"></i></a>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="verify">
                    <div class="verified">
                      <span><i class="la la-check"></i></span>
                      <a href="#">Verified</a>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="row">
                <div class="col-9">
                  <div class="media my-4">
                    <span class="mr-3"
                      ><i class="fa fa-cc-mastercard"></i
                    ></span>
                    <div class="media-body">
                      <h5 class="mt-0 mb-1">Master Card</h5>
                      <p>Credit Card *********5478</p>
                    </div>
                    <div class="edit-option">
                      <a href="#"><i class="fa fa-eye"></i></a>
                      <a href="#"><i class="fa fa-pencil"></i></a>
                      <a href="#"><i class="fa fa-trash"></i></a>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="verify">
                    <div class="verified">
                      <span><i class="la la-check"></i></span>
                      <a href="#">Verified</a>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="row">
                <div class="col-9">
                  <div class="media">
                    <span class="mr-3"><i class="fa fa-credit-card"></i></span>
                    <div class="media-body">
                      <h5 class="mt-0 mb-1">Debit Card</h5>
                      <p>Prepaid Card *********5478</p>
                    </div>
                    <div class="edit-option">
                      <a href="#"><i class="fa fa-eye"></i></a>
                      <a href="#"><i class="fa fa-pencil"></i></a>
                      <a href="#"><i class="fa fa-trash"></i></a>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="verify">
                    <div class="not-verify">
                      <span><i class="la la-close"></i></span>
                      <a href="#">Not verified</a>
                    </div>
                  </div>
                </div>
              </div>
            </li> -->
          </ul>

          <div class="mt-5">
            <router-link
              to="/new_bank_account"
              class="btn btn-primary px-4 mr-3"
              >Add Bank Account</router-link
            >
            <!-- <router-link to="/verify-step-1" class="btn btn-success px-4"
              >Add Debit Account</router-link
            > -->
          </div>
        </div>
      </div>
    </div>
  </dash-board-layout>
</template>

<script>
import DashBoardLayout from "../../../components/layouts/DashBoardLayout.vue";
import { payAccountList, del } from "../../../plugins/api/user_bank_acc";
export default {
  components: { DashBoardLayout },
  data() {
    return {
      data: [],
      allLoaded: false,
      topStatus: "",
      page: 1,
      per_page: 10,
      pager: {},
    };
  },
  mounted() {
    this.getdata();
  },
  created() {},
  methods: {
    delCard(id) {
      this.$confirm(
        "Are you sure you want to delete the card? The operation is not recoverable.",
        "Props",
        {
          confirmButtonText: "Enter",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          del({ ba_id: id }).then((res) => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "The deletion was successful!",
              });

              this.getdata();
            } else {
              this.$Message.error(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Undelete",
          });
        });
    },
    getdata() {
      payAccountList({ page: this.page, per_page: this.per_page }).then(
        (res) => {
          if (res.code == 0) {
            res.data.forEach((item) => {
              item.typeName = "Credit Card";
              item.cardName = "";
              switch (item.account_type) {
                case "bank":
                  item.cardName = "Bank Account";
                  item.typeName = "Bank Account";
                  break;
                case "mastercard":
                  item.cardName = "Master";
                  break;
                case "visa":
                  item.cardName = "Visa";
                  break;
                case "amex":
                  item.cardName = "American Express";
                  break;
                case "unionpay":
                  item.cardName = "Union";
                  item.typeName = "Debit Card";
                  break;
              }
              return item;
            });
            // console.log(cardlist);
            this.data = res.data;
            this.pager = res.meta.pagination;
            this.curPage = 1;
          }
        }
      );
    },
  },
};
</script>
